import React, { useContext } from 'react';
import { Route, Routes, ScrollToTop } from '@thd-olt-component-react/router';
import { AppContext } from '@thd-nucleus/app-render';
import { Error } from './pages';
import { getRoutes } from './routes';
import './styles/app.scss';

export const App = ({
  serverPages
}) => {

  const { instance } = useContext(AppContext);
  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;
  const routes = getRoutes(
    currentRouteName,
    currentRouteComponent,
    instance?.expContext?.experienceContext,
    serverPages
  );

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route exact path={routes.sbotd.path} element={<routes.sbotd.component />} />
        <Route exact path={routes.dailyDeals.path} element={<routes.dailyDeals.component />} />
        <Route exact path={routes.pro.path} element={<routes.pro.component />} />
        <Route path="/error" element={<Error />} />
        <Route element={<Error />} />
      </Routes>
    </>
  );
};
